import { useCallback, useRef } from 'react';
import { useIsomorphicEffect } from './useIsomorphicEffect';

/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */
export function useEventCallback<Args extends unknown[], Return>(
    fn: (...args: Args) => Return
): (...args: Args) => Return {
    const ref = useRef(fn);
    useIsomorphicEffect(() => {
        ref.current = fn;
    });
    return useCallback(
        (...args: Args) =>
            // eslint-disable-next-line
            // @ts-expect-error hide `this`
            // eslint-disable-next-line
            (0, ref.current!)(...args),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
}
